import { render } from "./sessionsView.vue?vue&type=template&id=4a4b43bb"
import script from "./sessionsView.vue?vue&type=script&lang=js"
export * from "./sessionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__